module.exports = __webpack_public_path__ + "static/media/swscrc3-3.77d3ee99.mp3";